export const gettext = window.gettext;
export const mediaUrl = window.app.config.mediaUrl;
export const siteRoot = window.app.config.siteRoot;
export const mainPageLogoURL = window.app.config.mainPageLogoURL;
export const showTutorialsVideo = window.app.config.showTutorialsVideo;
